import { render } from "./BlogDetailsPage.vue?vue&type=template&id=71f977d8"
import script from "./BlogDetailsPage.vue?vue&type=script&lang=js"
export * from "./BlogDetailsPage.vue?vue&type=script&lang=js"

import "./BlogDetailsPage.vue?vue&type=style&index=0&id=71f977d8&lang=css"

import exportComponent from "D:\\wamp64\\www\\safest\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__